import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import Closed from '@hvcgroep/design-system/assets/illustrations/Gesloten.svg';

interface Props {
  title: string
  dateLabel: string
}

const CalendarItemHoliday: React.FC<Props> = ({ title, dateLabel }) => {
  const { t } = useTranslation();

  const classes = c('CalendarItem', 'CalendarItem--holiday');

  return (
    <div className={classes} title={title}>
      <span className="sr-only">
        {dateLabel}
      </span>
      <div className="CalendarItem__title">
        {title}
      </div>
      <span className="sr-only">
        {t('waste_calendar.states.empty.no_pickup_moments')}
      </span>
      <img src={Closed} alt="" />
    </div>
  );
};

export default CalendarItemHoliday;
